import Vue from 'vue';
import Vuex from 'vuex';

import stocks from './modules/stocks';
import labels from './modules/labels';

import crosselings from './modules/crosselings';
import strings from './modules/globalStrings';

Vue.use( Vuex );
export default new Vuex.Store( {
    modules : {
        labels,
        strings,
        crosselings,
        stocks
    },
    labels      : state => {
        return state.labels;
    },
    stocks      : state => {
        return state.stocks;
    },
    strings     : state => {
        return state.strings;
    },
    crosselings : state => {
        return state.strings;
    }

});



// WEBPACK FOOTER //
// ./src/store/store.js